var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5"},[_c('datasetDetailsTop',{attrs:{"dataset-id":_vm.getID}}),_c('router-view',{attrs:{"name":"datasetDetailsSubpages"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }